import { AfterViewChecked, Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { TotemController } from '@shared/src/controllers/totem/totem.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { RouteCardDto } from '@shared/src/dtos/route/RouteCardDto';
import { environment, HString, PhaseCardDto, PhaseController, SecurityController, ShipmentCardDto, ShipmentController } from '@shared/src/public-api';

@Component({
  selector: 'shared-route-links',
  templateUrl: './shared.route.links.component.html',
  styleUrls: ['./shared.route.links.component.scss'],
})
export class SharedRouteLinksComponent implements AfterViewChecked {

  public useIonic: boolean = false;
  public hardmanUser: boolean = false;

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  public shouldResetScroll = false;

  ngAfterViewChecked() {
    if (this.shouldResetScroll) {
      this.resetScroll();
      this.shouldResetScroll = false;
    }
  }
  public totemRouteLinks: {
    exit?: string; none?: string; arrive?: string; signature?: string
  } = {};

  public totemLinks: {
    [phaseId: number]: {
      exit?: string; none?: string; arrive?: string; signature?: string
    }
  } = {};

  constructor(
    @Inject('HomeController') public homeController: HomeController,
    public activatedRoute: ActivatedRoute,
    public totemController: TotemController,
    public router: Router,
    public routeController: RouteController,
    public shipmentController: ShipmentController,
    public phaseController: PhaseController,
    @Inject("SecurityController") securityController: SecurityController
  ) {
    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();

    if (securityController) {
      securityController.isHardManUser().subscribe(a => {
        this.hardmanUser = a;
      });
    }
  }



  resetScroll() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollTop = 0;
      if (this.scrollContainer.nativeElement.parentElement != null)
        this.scrollContainer.nativeElement.parentElement.scrollTop = 0;
    }
  }

  public __route: RouteCardDto;
  @Input()
  public set route(value: RouteCardDto) {
    if (this.__route === value) return;
    this.__route = value;
    if (this.__route == null) {
      this.__routeId = 0;
    } else {
      this.__routeId = value.routeId;

      this.shipmentController.getShipmentsInRouteByRouteId(value.routeId).subscribe(data => {
        this.shipments = data;
      });

      this.phaseController.getSlotPhasesByRoute(value.routeId).subscribe(data => {
        this.phases = data;
        this.precargarTotemLinks(this.phases);
      });
      this.shouldResetScroll = true;
    }
  }
  public get route(): RouteCardDto { return this.__route; }

  public __routeId: number;
  @Input()
  set routeId(value: number) {
    if (this.__routeId === value) return;
    this.__routeId = value;
    this.routeController.getRoute(value).subscribe(route => {
      this.route = route;
    });

  }
  get routeId(): number { return this.__routeId; }

  setShowTotemTitle() {
    this.showTotemTitle = true;
    return '';
  }

  public showTotemTitle: boolean = false;
  public shipments: ShipmentCardDto[];
  public phases: PhaseCardDto[];

  public __phase: PhaseCardDto;
  @Input()
  public set phase(value: PhaseCardDto) {
    if (this.__phase === value) return;
    this.__phase = value;
    if (this.__phase == null) {
      this.__phaseId = 0;
    } else {
      this.__phaseId = value.phaseId;
      this.shipmentController.getShipmentsByPhaseId(value.phaseId).subscribe(data => {
        this.shipments = data;
      });
      this.routeController.getRoute(value.routeId).subscribe(route => {
        if (route)
          this.uuidPhase = route.uuidExwork;
      });

      this.precargarTotemLinks([this.__phase]);
      this.shouldResetScroll = true;
    }
  }
  public get phase(): PhaseCardDto { return this.__phase; }

  public __phaseId: number;
  @Input()
  set phaseId(value: number) {
    if (this.__phaseId === value) return;
    this.__phaseId = value;
    this.phaseController.getPhase(value).subscribe(phase => {
      this.phase = phase;
    });
  }
  get phaseId(): number { return this.__phaseId; }

  public optionExpanded: string = "";
  uuidPhase: string = null;

  private precargarTotemLinks(phases: PhaseCardDto[]) {

    if (!HLong.isNullOrNullLong(this.phaseId)) {
      // Phase
      this.totemController.getUrisByPhase(this.phaseId)
        .subscribe(v => {
          if (v[0])
            this.totemRouteLinks.none = v[0];
          if (v[1])
            this.totemRouteLinks.arrive = v[1];
          if (v[2])
            this.totemRouteLinks.exit = v[2];
          if (v[3])
            this.totemRouteLinks.signature = v[3];
        });

    } else if (!HLong.isNullOrNullLong(this.routeId)) {
      // Ruta
      this.totemController.getUrisByRoute(this.routeId)
        .subscribe(v => {
          if (v[0])
            this.totemRouteLinks.none = v[0];
          if (v[1])
            this.totemRouteLinks.arrive = v[1];
          if (v[2])
            this.totemRouteLinks.exit = v[2];
          if (v[3])
            this.totemRouteLinks.signature = v[3];
        });

      phases.forEach(p => {
        if (!this.totemLinks[p.phaseId]) this.totemLinks[p.phaseId] = {};
        this.totemController.getUrisByPhase(p.phaseId)
          .subscribe(v => {
            if (v[0])
              this.totemLinks[p.phaseId].none = v[0];
            if (v[1])
              this.totemLinks[p.phaseId].arrive = v[1];
            if (v[2])
              this.totemLinks[p.phaseId].exit = v[2];
            if (v[3])
              this.totemLinks[p.phaseId].signature = v[3];
          });
      });
    }

  }

  onClickLinkOption(option: string, shipment: ShipmentCardDto, phase: PhaseCardDto) {
    const currentPhase = phase ?? this.phase;

    switch (option) {
      case "terceros":
        if (currentPhase) {
          if (this.uuidPhase != null)
            window.open(this.homeController.getRouteToExWork(this.uuidPhase), "_blank");
        } else
          window.open(this.homeController.getRouteToExWork(this.route.uuidExwork), "_blank");
        break;

      case "track":
        if (shipment)
          window.open("/track/shipment/" + shipment.readUuid, "_blank");
        break;

      case "signatureExit":
        if (currentPhase)
          window.open(`/operation/activeslots?routeId=${currentPhase.routeId}&option=phaseSignatureCMR&phaseId=${currentPhase.phaseId}`, "_blank");
        break;

      case "totemRoute":
        if (this.totemRouteLinks?.none)
          window.open(this.totemRouteLinks.none, "_blank");
        break;

      case "totemEnterRoute":
        if (this.totemRouteLinks?.arrive)
          window.open(this.totemRouteLinks.arrive, "_blank");
        break;

      case "totemExitRoute":
        if (this.totemRouteLinks?.exit)
          window.open(this.totemRouteLinks.exit, "_blank");
        break;

      case "totemSignatureRoute":
        if (this.totemRouteLinks?.signature)
          window.open(this.totemRouteLinks.signature, "_blank");
        break;

      case "totem":
        if (currentPhase && this.totemLinks[currentPhase.phaseId]?.none)
          window.open(this.totemLinks[currentPhase.phaseId].none, "_blank");
        break;

      case "totemEnter":
        if (currentPhase && this.totemLinks[currentPhase.phaseId]?.arrive)
          window.open(this.totemLinks[currentPhase.phaseId].arrive, "_blank");
        break;

      case "totemExit":
        if (currentPhase && this.totemLinks[currentPhase.phaseId]?.exit)
          window.open(this.totemLinks[currentPhase.phaseId].exit, "_blank");
        break;

      case "totemSignature":
        if (currentPhase && this.totemLinks[currentPhase.phaseId]?.signature)
          window.open(this.totemLinks[currentPhase.phaseId].signature, "_blank");
        break;

      default:
        alert(option);
        break;
    }
  }

  getLink(option: string, shipment?: ShipmentCardDto, phase?: PhaseCardDto): string {
    const currentPhase = phase ?? this.phase;

    switch (option) {
      case "terceros":
        return currentPhase
          ? this.homeController.getRouteToExWork(this.uuidPhase)
          : this.homeController.getRouteToExWork(this.route.uuidExwork);

      case "track":
        return shipment ? environment.BASE_URI + `/track/shipment/${shipment.readUuid}` : null;

      case "signatureExit":
        return currentPhase
          ? environment.BASE_URI + `/operation/activeslots?routeId=${currentPhase.routeId}&option=phaseSignatureCMR&phaseId=${currentPhase.phaseId}`
          : null;

      case "totemRoute":
        return this.totemRouteLinks?.none;

      case "totemEnterRoute":
        return this.totemRouteLinks?.arrive;

      case "totemExitRoute":
        return this.totemRouteLinks?.exit;

      case "totemSignatureRoute":
        return this.totemRouteLinks?.signature;

      case "totem":
        return currentPhase ? this.totemLinks[currentPhase.phaseId]?.none : null;

      case "totemEnter":
        return currentPhase ? this.totemLinks[currentPhase.phaseId]?.arrive : null;

      case "totemExit":
        return currentPhase ? this.totemLinks[currentPhase.phaseId]?.exit : null;

      case "totemSignature":
        return currentPhase ? this.totemLinks[currentPhase.phaseId]?.signature : null;

      default:
        return null;
    }
  }

  getString(a: string) {
    if (HString.isNullOrNullString(a))
      return "---";
    return a;
  }


  public pretty(value) {
    return JSON.stringify(value);
  }
}
